import React from 'react';
import { AttributeTypeFormModal } from '@/pages/attributes/components/attributeTypeFormModal';
import { useCreateAttributeType } from '@/pages/attributes/useCreateAttributeType';
import { PATH } from '@/router/PATH';
import type { ActionSurfaceProps } from '../../controlCenterSurfaces';

/**
 * "Add attribute type" from the launcher. See `AddBrandSurface` for the shape.
 *
 * The **type** only — Colour, Size — not its values. Values are managed per
 * type from the attributes page's own row action, inside a sheet that already
 * knows which type it is editing; there is nothing for a launcher to open. The
 * confirmation links there, which is where the new type's values are added.
 */
export const AddAttributeTypeSurface: React.FC<ActionSurfaceProps> = ({
    onClose,
    onDone,
}) => {
    const [error, setError] = React.useState<string | null>(null);
    const { create, isCreating } = useCreateAttributeType();

    return (
        <AttributeTypeFormModal
            error={error}
            initialValues={null}
            isOpen
            isSubmitting={isCreating}
            mode="create"
            onClose={onClose}
            onSubmit={async (input) => {
                setError(null);
                const created = await create(input);
                if (!created.ok) {
                    setError(created.message);
                    return;
                }
                onDone({
                    messageKey: 'controlCenter.outcome.attributeTypeAdded',
                    messageParams: { name: input.name },
                    to: PATH.ATTRIBUTES,
                    linkKey: 'controlCenter.outcome.openAttributes',
                });
            }}
        />
    );
};
